





















































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import CardModel from '@/_models/CardModel'
import { Constant } from '@/_services/constant'

@Component({
  components: {},
  computed: {},
})
export default class SearchCard extends Vue {
  // Props
  @Prop()
  selectedData!: any

  @Prop({ default: false })
  isSmartCardSearch!: boolean
  // data
  currentPage: number = 1
  perPage: number = 10
  numofPage: number = 1
  isFormModalActive: boolean = false
  searchQuery: string = ''
  selectedFilter: string = 'san_id'
  selected: any = {}

  filedNameLUT: any = {
    _id: 'UUID',
    san_id: 'label.san_id',
    category_name: 'label.category_name',
  }

  // computed
  get cards(): CardModel[] {
    const cards = this.$store.state.cards.all.items
    this.numofPage = Math.ceil(cards.length / this.perPage)

    return cards
  }

  get isLoading(): boolean {
    return this.$store.state.cards.loading
  }

  get disabledSelectRow(): any {
    return (row): boolean => {
      return row.user_id !== '' && row._id !== this.selectedData._id
    }
  }

  get filteredData(): CardModel[] {
    const targetField: string = this.selectedFilter
    if (!this.cards) {
      return []
    }

    return this.cards.filter((item: any): boolean => {
      return (
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.searchQuery.toLowerCase()) !== -1
      )
    })
  }

  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  handleSelectFinished(): void {
    const selectedData = {
      _id: this.selected._id || '',
      san_id: this.selected.san_id || '',
    }

    this.$emit('handleSelectedCardDone', selectedData)
  }

  @Watch('selected')
  async selectedChanged() {
    if (!this.selected._id) {
      return
    }

    if (this.disabledSelectRow(this.selected)) {
      this.resetSelected()
    }
  }

  handleToggleSelected(): void {
    if (this.selected._id) {
      this.resetSelected()
    }
  }

  resetSelected(): void {
    this.selected = {}
  }

  // After page created
  created() {
    this.$store
      .dispatch('cards/getAll', {
        card_type: Constant.CARD_TYPE_CARRIED,
        jcard_type: this.isSmartCardSearch
          ? Constant.CARD_TYPE_SMARTJCARD
          : Constant.CARD_TYPE_JCARD,
      })
      .then(() => {
        for (const item of this.filteredData) {
          if (
            typeof this.selectedData !== 'undefined' &&
            this.selectedData &&
            item._id === this.selectedData._id
          ) {
            this.selected = item
            return
          }
        }
      })
  }
}
